import { Button, Popconfirm } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import UserApi from '../../functions/api/user/UserApi';
import MyUtil from '../../functions/MyUtil';

export default class ButtonFormatter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      edit: false,
      userInfo: '',
    };

    this.toggle = this.toggle.bind(this);
  }

  onChangeList = async () => {
    const { row } = this.props;
    await UserApi.deleteUser(row.user_acc_id);
    const listUser = await UserApi.getUserByRole('2,3');
    await this.props.onChangeList(listUser);
  };

  handleEdit = () => {
    const { edit } = this.state;
    this.setState({
      edit: !edit,
    });
  };

  async toggle() {
    const { userInfo, modal } = this.state;
    const { row } = this.props;
    if (!userInfo) {
      const detail = await UserApi.getUserById(row.user_acc_id);
      this.setState({ userInfo: detail });
    }
    this.setState({
      modal: !modal,
    });
  }

  render() {
    const { row } = this.props;
    const canEdit = MyUtil.hasPermission('/user', 'update');
    const canDelete = MyUtil.hasPermission('/user', 'delete');
    return (
      <div className="div-edit">
        {canEdit && (
          <Link to={`/user/edit/${row.user_acc_id}`}>
            <Button size="small" onClick={() => this.handleEdit()}>
              <i className="fas fa-edit"></i>
            </Button>
          </Link>
        )}
        {canDelete && (
          <Popconfirm
            title="Bạn chắc chắn muốn xóa?"
            onConfirm={() => this.onChangeList()}
          >
            <Button size="small" style={{ marginLeft: '2px' }} danger>
              <i className="fas fa-trash"></i>
            </Button>
          </Popconfirm>
        )}
      </div>
    );
  }
}
